import script from "./NumericQuestion.vue?vue&type=script&lang=ts&setup=true"
export * from "./NumericQuestion.vue?vue&type=script&lang=ts&setup=true"

import "./NumericQuestion.vue?vue&type=style&index=0&id=47d93552&lang=scss"

const __exports__ = script;

export default __exports__